import {RefObject, useCallback} from "react";
import queryString from "query-string";

export function useReviewFunctions() {
    const getPageNumFromUrl = useCallback(() => {
        const { page } = queryString.parse(window.location.search);
        if (page) {
            return Number(page as string);
        } else {
            return 0;
        }
    }, []);

    const getPage = useCallback((
        {pageNum, setPageNum,reviewListRef }:
        {pageNum: number | null, setPageNum: (_:number) => void, reviewListRef: RefObject<HTMLElement>}
    ) => {
        const nextPage = getPageNumFromUrl();
        if (!Number.isNaN(pageNum) && !Number.isNaN(nextPage) && pageNum !== nextPage) {
            setPageNum(nextPage);
            reviewListRef.current?.scrollIntoView();
        }
        // eslint-disable-next-line
    }, [getPageNumFromUrl]);

    return {
        getPageNumFromUrl, getPage
    }
}